// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-primary: #ffffff;
  --text-primary: #0f172a;
  --card-bg: #ffffff;
  --border-color: #e2e8f0;
  --muted-text: #64748b;
  --skeleton-base: #e2e8f0;
  --skeleton-highlight: #f8fafc;
  --accent: #0f766e;
}

[data-theme='dark'] {
  --bg-primary: #121212;
  --text-primary: #f8fafc;
  --card-bg: #1f1f1f;
  --border-color: #2f2f2f;
  --muted-text: #94a3b8;
  --skeleton-base: #2a2a2a;
  --skeleton-highlight: #3a3a3a;
  --accent: #14b8a6;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', Arial, sans-serif;
  margin: 0;
  background: var(--bg-primary);
  color: var(--text-primary);
}

button {
  cursor: pointer;
}

.app-shell {
  min-height: 100vh;
  position: relative;
  background-color: var(--bg-primary);
}

.login-container {
  max-width: 420px;
  margin: 64px auto;
  padding: 24px;
  display: grid;
  gap: 12px;
  text-align: center;
}

.btn-primary {
  border: none;
  background: var(--accent);
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 600;
}

.btn-primary:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.app-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
  background: var(--card-bg);
}

.app-nav__links {
  display: flex;
  gap: 12px;
}

.nav-link {
  color: var(--muted-text);
  text-decoration: none;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.nav-link:hover {
  background: var(--skeleton-highlight);
  color: var(--text-primary);
}

.nav-link.active {
  color: var(--accent);
  background: rgba(15, 118, 110, 0.1);
  font-weight: 700;
}

.app-nav__user {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--muted-text);
}

.app-nav__name {
  color: var(--text-primary);
}

.install-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: linear-gradient(90deg, rgba(15, 118, 110, 0.1), transparent);
  border-bottom: 1px solid var(--border-color);
  font-weight: 600;
}

.install-banner button {
  border: none;
  background: var(--accent);
  color: #fff;
  padding: 6px 14px;
  border-radius: 999px;
}

.auth-bypass-watermark {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  color: rgba(220, 38, 38, 0.12);
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  text-transform: uppercase;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.auth-bypass-watermark span {
  transform: rotate(-24deg);
  letter-spacing: 0.2em;
}

.auth-bypass-banner {
  background-color: #dc2626;
  color: #fff;
  text-align: center;
  font-size: 14px;
  padding: 8px 16px;
  font-weight: 600;
}

.skeleton {
  background: linear-gradient(90deg,
      var(--skeleton-base) 25%,
      var(--skeleton-highlight) 50%,
      var(--skeleton-base) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite linear;
  border-radius: 6px;
}

.skeleton-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.skeleton-avatar {
  width: 36px;
  height: 36px;
  border-radius: 999px;
}

.skeleton-line {
  height: 12px;
  width: 120px;
  border-radius: 999px;
}

.skeleton-line--wide {
  width: 220px;
}

.skeleton-card {
  height: 120px;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 0 24px;
}

.profile-header__text {
  display: grid;
  gap: 8px;
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.table-skeleton {
  display: grid;
  gap: 12px;
}

.safe-mode {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: radial-gradient(circle at top, rgba(15, 118, 110, 0.12), transparent 55%);
  padding: 24px;
}

.safe-mode__card {
  max-width: 420px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
}

.safe-mode__card h1 {
  margin-top: 0;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

/* Utilities */
.card-bg {
  background-color: var(--card-bg) !important;
  color: var(--text-primary);
  border-color: var(--border-color) !important;
}

.input-bg {
  background-color: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border-color) !important;
}

.secondary-bg {
  background-color: var(--skeleton-highlight) !important;
  color: var(--text-primary);
}

.tag-default {
  background-color: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border-color) !important;
}

.text-primary {
  color: var(--text-primary) !important;
}

.text-muted {
  color: var(--muted-text) !important;
}

/* React Quill Dark Mode Overrides */
[data-theme='dark'] .ql-toolbar {
  background-color: var(--card-bg) !important;
  border-color: var(--border-color) !important;
}

[data-theme='dark'] .ql-container {
  background-color: var(--bg-primary) !important;
  color: var(--text-primary) !important;
  border-color: var(--border-color) !important;
}

[data-theme='dark'] .ql-editor.ql-blank::before {
  color: var(--muted-text) !important;
}

/* Handle SVG strokes (icons) */
[data-theme='dark'] .ql-snow .ql-stroke {
  stroke: var(--text-primary) !important;
}

/* Handle SVG fills (icons like triangles) */
[data-theme='dark'] .ql-snow .ql-fill,
[data-theme='dark'] .ql-snow .ql-stroke.ql-fill {
  fill: var(--text-primary) !important;
}

/* Picker labels (dropdowns) */
[data-theme='dark'] .ql-snow .ql-picker {
  color: var(--text-primary) !important;
}

[data-theme='dark'] .ql-snow .ql-picker-options {
  background-color: var(--card-bg) !important;
  border-color: var(--border-color) !important;
}
.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid var(--accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 20px auto;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE;qDACmD;EACnD,SAAS;EACT,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,wEAAwE;EACxE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;;;+BAG6B;EAC7B,0BAA0B;EAC1B,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,qFAAqF;EACrF,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,cAAc;AACd;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,sDAAsD;EACtD,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;AACrC;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;AACxC;;AAEA,4CAA4C;AAC5C;;EAEE,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mCAAmC;IACnC,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC","sourcesContent":[":root {\n  --bg-primary: #ffffff;\n  --text-primary: #0f172a;\n  --card-bg: #ffffff;\n  --border-color: #e2e8f0;\n  --muted-text: #64748b;\n  --skeleton-base: #e2e8f0;\n  --skeleton-highlight: #f8fafc;\n  --accent: #0f766e;\n}\n\n[data-theme='dark'] {\n  --bg-primary: #121212;\n  --text-primary: #f8fafc;\n  --card-bg: #1f1f1f;\n  --border-color: #2f2f2f;\n  --muted-text: #94a3b8;\n  --skeleton-base: #2a2a2a;\n  --skeleton-highlight: #3a3a3a;\n  --accent: #14b8a6;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans',\n    'Droid Sans', 'Helvetica Neue', Arial, sans-serif;\n  margin: 0;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.app-shell {\n  min-height: 100vh;\n  position: relative;\n  background-color: var(--bg-primary);\n}\n\n.login-container {\n  max-width: 420px;\n  margin: 64px auto;\n  padding: 24px;\n  display: grid;\n  gap: 12px;\n  text-align: center;\n}\n\n.btn-primary {\n  border: none;\n  background: var(--accent);\n  color: #fff;\n  padding: 10px 16px;\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n.btn-primary:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.app-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--card-bg);\n}\n\n.app-nav__links {\n  display: flex;\n  gap: 12px;\n}\n\n.nav-link {\n  color: var(--muted-text);\n  text-decoration: none;\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.nav-link:hover {\n  background: var(--skeleton-highlight);\n  color: var(--text-primary);\n}\n\n.nav-link.active {\n  color: var(--accent);\n  background: rgba(15, 118, 110, 0.1);\n  font-weight: 700;\n}\n\n.app-nav__user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--muted-text);\n}\n\n.app-nav__name {\n  color: var(--text-primary);\n}\n\n.install-banner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  background: linear-gradient(90deg, rgba(15, 118, 110, 0.1), transparent);\n  border-bottom: 1px solid var(--border-color);\n  font-weight: 600;\n}\n\n.install-banner button {\n  border: none;\n  background: var(--accent);\n  color: #fff;\n  padding: 6px 14px;\n  border-radius: 999px;\n}\n\n.auth-bypass-watermark {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: grid;\n  place-items: center;\n  color: rgba(220, 38, 38, 0.12);\n  font-size: clamp(2.5rem, 5vw, 4rem);\n  font-weight: 700;\n  text-transform: uppercase;\n  pointer-events: none;\n  user-select: none;\n}\n\n.auth-bypass-watermark span {\n  transform: rotate(-24deg);\n  letter-spacing: 0.2em;\n}\n\n.auth-bypass-banner {\n  background-color: #dc2626;\n  color: #fff;\n  text-align: center;\n  font-size: 14px;\n  padding: 8px 16px;\n  font-weight: 600;\n}\n\n.skeleton {\n  background: linear-gradient(90deg,\n      var(--skeleton-base) 25%,\n      var(--skeleton-highlight) 50%,\n      var(--skeleton-base) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite linear;\n  border-radius: 6px;\n}\n\n.skeleton-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.skeleton-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 999px;\n}\n\n.skeleton-line {\n  height: 12px;\n  width: 120px;\n  border-radius: 999px;\n}\n\n.skeleton-line--wide {\n  width: 220px;\n}\n\n.skeleton-card {\n  height: 120px;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 16px 0 24px;\n}\n\n.profile-header__text {\n  display: grid;\n  gap: 8px;\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.table-skeleton {\n  display: grid;\n  gap: 12px;\n}\n\n.safe-mode {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  background: radial-gradient(circle at top, rgba(15, 118, 110, 0.12), transparent 55%);\n  padding: 24px;\n}\n\n.safe-mode__card {\n  max-width: 420px;\n  background: var(--card-bg);\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  padding: 24px;\n  text-align: center;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);\n}\n\n.safe-mode__card h1 {\n  margin-top: 0;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n/* Utilities */\n.card-bg {\n  background-color: var(--card-bg) !important;\n  color: var(--text-primary);\n  border-color: var(--border-color) !important;\n}\n\n.input-bg {\n  background-color: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n.secondary-bg {\n  background-color: var(--skeleton-highlight) !important;\n  color: var(--text-primary);\n}\n\n.tag-default {\n  background-color: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n.text-primary {\n  color: var(--text-primary) !important;\n}\n\n.text-muted {\n  color: var(--muted-text) !important;\n}\n\n/* React Quill Dark Mode Overrides */\n[data-theme='dark'] .ql-toolbar {\n  background-color: var(--card-bg) !important;\n  border-color: var(--border-color) !important;\n}\n\n[data-theme='dark'] .ql-container {\n  background-color: var(--bg-primary) !important;\n  color: var(--text-primary) !important;\n  border-color: var(--border-color) !important;\n}\n\n[data-theme='dark'] .ql-editor.ql-blank::before {\n  color: var(--muted-text) !important;\n}\n\n/* Handle SVG strokes (icons) */\n[data-theme='dark'] .ql-snow .ql-stroke {\n  stroke: var(--text-primary) !important;\n}\n\n/* Handle SVG fills (icons like triangles) */\n[data-theme='dark'] .ql-snow .ql-fill,\n[data-theme='dark'] .ql-snow .ql-stroke.ql-fill {\n  fill: var(--text-primary) !important;\n}\n\n/* Picker labels (dropdowns) */\n[data-theme='dark'] .ql-snow .ql-picker {\n  color: var(--text-primary) !important;\n}\n\n[data-theme='dark'] .ql-snow .ql-picker-options {\n  background-color: var(--card-bg) !important;\n  border-color: var(--border-color) !important;\n}\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid var(--accent);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 20px auto;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
